<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section aria-labelledby="pt2" epub:type="part" role="doc-part">
<p class="sp"> </p>
<header>
<h1 class="PN" id="pt2"><span href="#/xhtml/contents#c_pt2" title="Link target outside of Sample"><span aria-label="21" id="pg_21" role="doc-pagebreak">2</span></span></h1>
<h1 class="PT"><span href="#/xhtml/contents#c_pt2" title="Link target outside of Sample">VIOLET AND THE CARPETS</span></h1>
</header>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part2.vue?577dbc38